import React from 'react';
import { motion } from 'framer-motion';
export function ClosingTimeline() {
  const steps = [{
    label: 'Submit Loan',
    time: 'DAY 1',
    active: true
  }, {
    label: 'Underwriting',
    time: 'DAY 2–3',
    active: true
  }, {
    label: 'Conditions',
    time: 'DAY 4–8',
    active: true
  }, {
    label: 'Clear to Close',
    time: 'DAY 9–10',
    active: true
  }, {
    label: 'Funded!',
    time: '~12 DAYS',
    active: true,
    highlight: true
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    delay: 1.0,
    duration: 0.8,
    ease: 'easeOut'
  }} className="py-2" data-id="element-3">
      <div className="text-[10px] font-medium tracking-[0.2em] text-gold mb-10 flex items-center gap-3" data-id="element-4">
        <span className="text-gold/50" data-id="element-5">—</span> CLOSING TIMELINE
      </div>

      <div className="relative" data-id="element-6">
        {/* Connecting Line */}
        <div className="absolute top-1.5 left-6 right-6 h-[1px] bg-white/15 -z-10" data-id="element-7"></div>

        <div className="flex justify-between" data-id="element-8">
          {steps.map((step, index) => <div key={index} className="flex flex-col items-center w-20 text-center" data-id="element-9">
              <div className={`w-3 h-3 rounded-full mb-4 flex items-center justify-center border-2 border-charcoal-800 ${step.active ? 'bg-gold' : 'bg-white/20'}`} data-id="element-10"></div>
              <div className={`text-[9px] tracking-[0.15em] mb-1.5 ${step.highlight ? 'text-gold' : 'text-gray-500'}`} data-id="element-11">
                {step.time}
              </div>
              <div className={`text-xs font-light ${step.highlight ? 'text-gold' : 'text-white'}`} data-id="element-12">
                {step.label}
              </div>
            </div>)}
        </div>
      </div>
    </motion.div>;
}